import React from 'react'
import "./UserProfileImage.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons'

function UserProfileImage({ profileImagePath, width, height, selected }) {
    return (
        <div>
            { profileImagePath !== "" && profileImagePath !== null &&profileImagePath !== undefined ?
                <img src={profileImagePath}
                className="profile-img"
                alt="profile image"
                loading="lazy"
                style={{
                    width: width || 35,
                    height: height || 35
                }}
                />
                :
                <FontAwesomeIcon
                icon={faUserCircle}
                className="profile-img-placeholder"
                style={{ 
                    fontSize: width,
                    color: selected ? 'white': 'gray'
                }}
                />
                }
        </div>
    )
}

export default UserProfileImage
